export default function validate(values) {
    let errors = {};
  
    if (!values.main_text) {
      errors.main_text = 'A name is required';
    }  
    
    return errors;
  };